import { API_CONFIG, fetchAPI } from './api';

export type PepProfile = {
  brandVoice: string;
  icpPersona: string;
  offersProducts: string;
  languageDos: string;
  languageDonts: string;
  channelConstraints: string;
  sequencePolicy: string;
  touchpointRules: string;
  approvalMode: 'manual' | 'autopilot';
  updatedAt?: string;
};

export type PepProfileResponse = {
  success: boolean;
  email?: string;
  locked?: boolean;
  profile?: PepProfile;
  error?: string;
};

export async function getPepProfile(email: string): Promise<PepProfileResponse> {
  return fetchAPI<PepProfileResponse>(API_CONFIG.USERS_API, {
    method: 'POST',
    body: JSON.stringify({
      action: 'get_pep_profile',
      email,
    }),
  });
}

export async function savePepProfile(email: string, profile: PepProfile): Promise<PepProfileResponse> {
  return fetchAPI<PepProfileResponse>(API_CONFIG.USERS_API, {
    method: 'POST',
    body: JSON.stringify({
      action: 'save_pep_profile',
      email,
      profile,
    }),
  });
}

export async function getPepCompanyProfile(email: string, companyName: string): Promise<PepProfileResponse> {
  return fetchAPI<PepProfileResponse>(API_CONFIG.USERS_API, {
    method: 'POST',
    body: JSON.stringify({
      action: 'get_pep_company_profile',
      email,
      companyName,
    }),
  });
}

export async function savePepCompanyProfile(
  email: string,
  companyName: string,
  profile: PepProfile | null
): Promise<PepProfileResponse> {
  return fetchAPI<PepProfileResponse>(API_CONFIG.USERS_API, {
    method: 'POST',
    body: JSON.stringify({
      action: 'save_pep_company_profile',
      email,
      companyName,
      profile,
    }),
  });
}
